module.exports = __webpack_public_path__ + "static/media/13․051.8711fe91.jpg";